import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Rx';

import { Link } from '../link.model';
import { Campaign } from '../../campaigns/campaign.model';
import { LinkService } from '../link.service';

@Component({
  selector: 'wm-link-edit',
  template: require('./link-edit.component.html')
})

export class LinkEditComponent implements OnInit {
  @Input() campaign: Campaign;
  @Output() linkAdd = new EventEmitter();

  link: Link;
  links: Link[];

  loading = true;

  linkForm: FormGroup;
  submitted: boolean;
  formErrors: Object;

  // tslint:disable-next-line:max-line-length
  urlPattern = 'https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.[^\\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.[^\\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\\s]{2,}|www\.[a-zA-Z0-9]\.[^\\s]{2,}';

  validationMessages = {
    'origin_url': {
      required: 'Cсылка не указана',
      pattern: 'Неверный формат ссылки'
    },
    'refer_url': {
      required: 'Адрес размещения не указан',
      pattern: 'Неверный формат адреса'
    }
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: LinkService
  ) { }

  ngOnInit() {
    this.initFormErrors();
    this.buildForm();
    this.submitted = false;
  }

  buildForm() {
    this.linkForm = this.fb.group({
      origin_url: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      refer_url: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      channel: ['']
    });
  }

  initFormErrors() {
    this.formErrors = {origin_url: '', refer_url: '', channel: ''};
  }

  onSubmit(model: Link, valid: boolean) {
    this.submitted = true;

    if (!valid) {
      this.validateForm();

      return false;
    }

    if (!model.channel) {
      delete model.channel;
    }

    this.service.createLink(this.campaign.id, model).subscribe(result => {
      this.linkAdd.emit(result['link']);
      this.initFormErrors();
      this.buildForm();
      this.submitted = false;
    });

    return false;
  }

  validateForm() {
    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
      let input = this.linkForm.get(field);

      if ((input.invalid && input.dirty) || this.submitted) {
        if (!!input.errors) {
          for (let error of Object.keys(input.errors)) {
            this.formErrors[field] = this.validationMessages[field][error];
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/links/components/link-edit.component.ts